<template>
  <div class="filter-label shadow" :id="`filter_label-${filterKey}`">
    <span class="filter-value" @click="$emit('openPopup', title)">
      <span class="font-bold">{{ title }}: </span>
      <span>{{ value }}</span>
    </span>
    <button class="!bg-transparent" @click="$emit('resetFilterAcrossUI', filterKey)">
      <i class="fa fa-times"></i>
    </button>
  </div>
</template>

<script setup>
  import { ref, onMounted } from "vue";

  const props = defineProps({
    filterKey:  { type: String, required: true },  // The actual key "user_session_statuses"
    title:      { type: String, required: true },  // The display name "User session statuses"
    value:      { type: String, required: true }   // The filter value
  })

  const emit = defineEmits([
    'resetFilterAcrossUI',
    'openPopup',
  ])

  onMounted(() => {
  })
</script>